module.exports = ".user-lookup-dialog {\n  min-width: 600px; }\n\n.full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/user-lookup/user-lookup.component.scss
// module id = ./src/app/shared/components/user-lookup/user-lookup.component.scss
// module chunks = main